module.exports = __webpack_public_path__ + "static/media/refresh-svgrepo-com.8a145179.svg";